
























import { Component, Prop, Vue } from "vue-property-decorator";
import Tooltip from "../utility/tooltip.vue";
import CustomFieldDetailIcon from "./CustomFieldDetailIcon.vue";
import { ICustomField } from "@/models/custom-field.entity";

@Component({
  components: {
    Tooltip,
    CustomFieldDetailIcon
  }
})
export default class CustomFieldChip extends Vue {
  @Prop({ required: true })
  value!: ICustomField;

  @Prop({ default: "medium" })
  size?: "x-small" | "small" | "medium" | "large" | "x-large";

  @Prop({ default: false })
  draggable!: boolean;
}
